import React, { useState, useEffect } from "react"
import { Link, useParams } from "react-router-dom"
import { Col, Row, UncontrolledAlert, Spinner } from "reactstrap"
import api from "API/Api"
import { AvForm, AvField } from "availity-reactstrap-validation"
import loader from "./../../../../assets/loading/loader.gif"

const EditVendorRecovery = () => {
  const { id } = useParams()
  const [submitted, setSubmitted] = useState(false)
  const [loading, setLoading] = useState(false)
  const [pageLoading, setPageLoading] = useState(true)
  const [recovery, setRecovery] = useState(null)
  const [centers, setCenters] = useState([])
  const [routes, setRoutes] = useState([])
  const [vendors, setVendors] = useState([])

  useEffect(() => {
    const getInfo = async () => {
      try {
        const [recResp, chilResp, rouResp, vendResp] = await Promise.all([
          api.get("vendor-recovery/" + id), api.get("centers"), api.get("routes"), api.get("vendors")
        ])
        setRecovery(recResp.data.data?.[0] || recResp.data.data)
        setCenters(Array.isArray(chilResp.data.data) ? chilResp.data.data : chilResp.data.data?.data || [])
        setRoutes(Array.isArray(rouResp.data.data) ? rouResp.data.data : rouResp.data.data?.data || [])
        setVendors(Array.isArray(vendResp.data.data) ? vendResp.data.data : vendResp.data.data?.data || [])
      } catch (err) { console.error(err) }
      setPageLoading(false)
    }
    getInfo()
  }, [id])

  const handleValidSubmit = async (event, values) => {
    setLoading(true)
    try {
      const response = await api.put("update-vendor-recovery/" + id, values)
      if (response.data.success === true) { setSubmitted(true); setTimeout(() => setSubmitted(false), 3000) }
    } catch (error) { console.error(error) }
    setLoading(false)
  }

  if (pageLoading) return <div className="dashBody"><img className="loaderImg" src={loader} alt="Loading" /></div>
  if (!recovery) return <div className="dashBody"><p>Recovery not found</p></div>

  return (
    <div className="dashBody">
      <div className="font-size-18 mb-0 dashHeader">
        <Row>
          <Col md={6}><h4>Edit Vendor Recovery</h4></Col>
          <Col md={6} style={{ textAlign: "right" }}><Link to="/vendor-recoveries" className="dashBtn"><i className="fas fa-chevron-left"></i> <b>Back</b></Link></Col>
        </Row>
      </div>
      <div className="dashContent">
        <AvForm className="form-horizontal" onValidSubmit={handleValidSubmit}>
          <Row>
            <Col md={6}><div className="mb-3">
              <AvField type="select" name="chillingCenter" label="Chilling Center *" required value={String(recovery.chillingCenter)}>
                <option value="">Select Chilling Center</option>
                {centers.map((c, i) => <option key={i} value={String(c.id)}>{c.name}</option>)}
              </AvField>
            </div></Col>
            <Col md={6}><div className="mb-3">
              <AvField type="select" name="route" label="Route *" required value={String(recovery.route)}>
                <option value="">Select Route</option>
                {routes.map((r, i) => <option key={i} value={String(r.id)}>{r.routeName}</option>)}
              </AvField>
            </div></Col>
          </Row>
          <Row>
            <Col md={6}><div className="mb-3">
              <AvField type="select" name="vendor" label="Vendor *" required value={String(recovery.vendor)}>
                <option value="">Select Vendor</option>
                {vendors.map((v, i) => <option key={i} value={String(v.id)}>{v.vendorName}</option>)}
              </AvField>
            </div></Col>
            <Col md={6}><div className="mb-3">
              <AvField name="recoveryDate" label="Recovery Date *" type="date" required value={recovery.recoveryDate} />
            </div></Col>
          </Row>
          <Row>
            <Col md={6}><div className="mb-3">
              <AvField name="recoveryAmount" label="Recovery Amount *" type="text" required value={recovery.recoveryAmount}
                validate={{ pattern: { value: /^[0-9,]+(\.[0-9]{1,2})?$/, errorMessage: "Enter a valid amount" } }} />
            </div></Col>
            <Col md={6}><div className="mb-3">
              <AvField name="remarks" label="Remarks" type="textarea" value={recovery.remarks} />
            </div></Col>
          </Row>
          <div className="mb-3 row mt-4">
            <div className="col-6">{submitted && <UncontrolledAlert color="success"><strong>Vendor Recovery Updated!</strong></UncontrolledAlert>}</div>
            <div className="col-6 text-end">
              <button className="btn btn-primary w-md waves-effect waves-light" type="submit" disabled={loading}>
                {loading ? <><Spinner size="sm" /> <span>Updating...</span></> : <span>Update Recovery</span>}
              </button>
            </div>
          </div>
        </AvForm>
      </div>
    </div>
  )
}
export default EditVendorRecovery
